// Every route of the web app. The consult pages live in src/consult/ and the
// admin screens in src/admin/. The admin is mounted as one component at
// /admin/* (AdminApp: its own routes, and the API provider its screens use);
// add admin screens inside src/admin/routes.tsx.
import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { CallPage } from "./consult/CallPage";
import { CheckInPage } from "./consult/CheckInPage";
import { ThanksPage } from "./consult/ThanksPage";
import { ResumePage } from "./consult/ResumePage";
import { NotFoundPage } from "./NotFoundPage";

// The admin is its own chunk: an owner opening the check-in never downloads it.
const AdminApp = lazy(() => import("./admin/routes").then((m) => ({ default: m.AdminApp })));

export const routes: RouteObject[] = [
  { path: "/", element: <CheckInPage /> },
  { path: "/call/:id", element: <CallPage /> },
  { path: "/thanks/:id", element: <ThanksPage /> },
  // The emailed link to finish an unfinished consult (CR-015): /resume#<token>.
  { path: "/resume", element: <ResumePage /> },
  {
    path: "/admin/*",
    element: (
      <Suspense fallback={null}>
        <AdminApp />
      </Suspense>
    ),
  },
  { path: "*", element: <NotFoundPage /> },
];
